var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-autocomplete-input',{attrs:{"value":_vm.value,"required":"","itemText":"name","itemValue":"value","label":_vm.label,"choices":_vm.items,"cache-items":"","min-chars":1},on:{"input":_vm.updateTimezone}})}
var staticRenderFns = []

export { render, staticRenderFns }